export default "__VITE_ASSET__BMY2qGUs__"